export default {
    getHistoryTableFields: state => state.headerFields,
    getHistoryDataTableOptions: state => state.dataTableOptions,
}
